import { styled } from "styled-components";

export const DivStyled = styled.div`
  display: flex;
  background-color: var(--base);
  border-radius: 40px;

  .box-right {
    width: calc(100% - 260px);
    height: 100vh;
    padding: 36px;
    background-color: var(--base01);
    border-radius: 40px;
  }

  .input-error {
    position: relative;
  }

  .flex {
    display: flex;
    align-items: center;
    margin-bottom: 32px;
  }
  .return {
    font-size: 40px;
    font-weight: 400;
    color: var(--principal);
    background-color: var(--amarelo);
    padding: 8px 7px;
    border-radius: 100px;
    margin-right: 10px;
  }

  .flex-input {
    display: flex;
    justify-content: space-between;
    width: 95%;
    align-items: baseline;
    margin-bottom: 10px;
  }

  .nome {
    width: 100%;
    max-width: 95%;
    margin-bottom: 20px;
  }

  .div-error {
    width: 45%;
  }

  input {
    height: 30px;
    border-radius: 6px 6px 6px 6px;
    border: none;
    padding: 18px 12px;
  }

  .width95 {
    input {
      width: 95%;
    }
  }

  .input {
    input {
      height: 42px;
      border: 1px solid hsl(0, 0%, 80%);
      margin-bottom: 28px;
    }
  }

  select {
    width: 100%;
    padding: 0px 12px;
    border-radius: 6px 6px;
    border: none;
    height: 42px;
    border: 1px solid hsl(0, 0%, 80%);
  }

  .cursor {
    cursor: pointer;
  }

  .div-select {
    display: flex;
    flex-direction: column;
    width: 45%;
    margin-bottom: 20px;
  }

  .input {
    width: 100%;
    max-width: none;
  }

  .nome-marca {
    margin: 10px 10px 0px;
  }

  .relative {
    position: relative;

    span {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 12px;
      cursor: pointer;
    }
  }

  button {
    background-color: var(--amarelo);
    color: var(--principal);
    border: none;
    padding: 8px 5px;
    border-radius: 20px;
    width: 10%;
    font-size: 1rem;
    font-weight: bold;
  }

  label {
    font-size: 0.9rem;
    font-weight: 600;
    margin-bottom: 5px;
  }

  h1 {
    font-size: 42px;
    font-weight: 600;
    margin-left: 10px;
    color: var(--principal);
  }

  .som {
    margin-left: 10px;
  }
`;
